let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("35m47")]).then(() => parcelRequire('6KxRp'));